import { Button, Form, Input } from 'antd';
import React from 'react';
import { useAuthState } from '../../../redux/selector';
import { Control, Controller } from 'react-hook-form';

export interface MultiFactorVerificationFormValues {
  verificationCode: string;
}

interface MultiFactorVerificationCodeFormProps {
  control: Control<MultiFactorVerificationFormValues>;
  submitText?: string;
  onSubmit: () => void;
}

const MultiFactorVerificationCodeForm: React.FC<MultiFactorVerificationCodeFormProps> = ({
  control,
  submitText,
  onSubmit,
}) => {
  const { loading } = useAuthState();
  return (
    <>
      <Form layout="vertical" onFinish={onSubmit}>
        <Controller
          control={control}
          name="verificationCode"
          rules={{
            required: 'Please input the verification code',
          }}
          render={({ field, fieldState }) => (
            <Form.Item validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
              <Input
                size="large"
                className="border-content-secondary shadow-none"
                autoCapitalize="off"
                autoCorrect="off"
                autoComplete="off"
                placeholder="Verification code"
                maxLength={VERIFICATION_CODE_LENGTH}
                {...field}
                onChange={(value) => {
                  field.onChange(value);
                  if (value.target.value.length === VERIFICATION_CODE_LENGTH) {
                    onSubmit();
                  }
                }}
              />
            </Form.Item>
          )}
        />
        {submitText && (
          <Form.Item>
            <Button size="large" type="primary" htmlType="submit" block loading={loading}>
              {submitText}
            </Button>
          </Form.Item>
        )}
      </Form>
    </>
  );
};

const VERIFICATION_CODE_LENGTH = 6;

export default MultiFactorVerificationCodeForm;
